import { render } from "./elem-table.vue?vue&type=template&id=754cf8bd&scoped=true&ts=true"
import script from "./elem-table.vue?vue&type=script&lang=ts"
export * from "./elem-table.vue?vue&type=script&lang=ts"

import "./elem-table.vue?vue&type=style&index=0&id=754cf8bd&lang=less&scoped=true"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754cf8bd"]])

export default __exports__